import { formatCurrencyBRL } from '@utils/currency.util';

export function formatInputCurrency(value: string): string {
  const numbers = value.replace(/\D/g, '');
  if (!numbers || Number(numbers) === 0) return '';

  const padded = numbers.padStart(3, '0');
  const cents = padded.slice(-2);
  const integer = (padded.slice(0, -2) || '0')
    .replace(/^0+/, '')
    .replace(/\B(?=(\d{3})+(?!\d))/g, '.');

  return `${integer || '0'},${cents}`;
}

export function formatPercentageInput(value: string): string {
  const normalizedValue = value.replace(/[^\d,.]/g, '');
  const decimalSeparatorIndex = normalizedValue.search(/[,.]/);

  if (decimalSeparatorIndex === -1) {
    return normalizedValue.replace(/^0+(?=\d)/, '');
  }

  const integer = normalizedValue.slice(0, decimalSeparatorIndex);
  const decimal = normalizedValue
    .slice(decimalSeparatorIndex + 1)
    .replace(/\D/g, '')
    .slice(0, 2);
  const normalizedInteger = integer.replace(/^0+(?=\d)/, '') || '0';
  return `${normalizedInteger},${decimal}`;
}

export function parsePercentageToBasisPoints(value: string): number {
  const parsedValue = Number(value.replace(',', '.'));
  return Number.isFinite(parsedValue) ? Math.round(parsedValue * 100) : 0;
}

export function formatBRLFromCents(valueInCents: number): string {
  return `R$ ${formatCurrencyBRL(valueInCents / 100)}`;
}
